// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"04805e60","455":"0d5715be","977":"797d754d"}[chunkId] + ".chunk.js";
};